import React from "react";
import { Link } from "react-router-dom";
import IMG1 from '../assets/img/sentiment_analysis.png';
import IMG2 from '../assets/img/real.png';
import IMG3 from '../assets/img/crack.png';
import IMG10 from '../assets/img/IMG10.png';
import IMG5 from '../assets/img/gevis.png';
import IMG9 from '../assets/img/IMG9.png';
import IMG11 from '../assets/img/doc.png';
import IMG12 from '../assets/img/rec.png';

const data = [
    {
        id: 1, 
        name: "DocAI",
        imgURL: IMG11,
        github: "https://github.com/AshiqNoor-S/GameDoo",
        demo: "https://ashiqnoor-s.github.io/GameDoo/"
    },
    {
        id: 2, 
        name: "Prompt4All",
        imgURL: IMG9,
        github: "https://github.com/AshiqNoor-S/Prompt4All",
        demo: "https://prompt4-all.vercel.app/"
    },
    {
        id: 3, 
        name: "Movie Recommendation System",
        imgURL: IMG12,
        github: "https://github.com/AshiqNoor-S/Movie-Recommendation-System",
        demo: "https://github.com/AshiqNoor-S/Movie-Recommendation-System"
    },
    {
        id: 4, 
        name: "Amazon Review Sentiment Analyser and Chatbot",
        imgURL: IMG1,
        github: "https://github.com/AshiqNoor-S/Amazon-Sentiment-analysis-and-Chatbot",
        demo: "https://qbgimvpmb9qzznejjkgjce.streamlit.app/"
    },
    {
        id: 5, 
        name: "Community Connect",
        imgURL: IMG10,
        github: "https://github.com/AshiqNoor-S/Community-Connect",
        demo: "https://community-connect-n7n2.vercel.app/"
    },
    {
        id: 6, 
        name: "RealStar",
        imgURL: IMG2,
        github: "https://github.com/AshiqNoor-S/Realstar",
        demo: "https://github.com/AshiqNoor-S/Realstar"
    },
    {
        id: 7, 
        name: "Gevis",
        imgURL: IMG5,
        github: "https://github.com/AshiqNoor-S/Gesture_Enabled-_System",
        demo: "https://github.com/AshiqNoor-S/Gesture_Enabled-_System"
    },
    {
        id: 8, 
        name: "Game Doo - Landing Page",
        imgURL: IMG3,
        github: "https://github.com/AshiqNoor-S/GameDoo",
        demo: "https://ashiqnoor-s.github.io/GameDoo/"
    }
];

const Project = () => {
    return (
        <section id="project">
            <h5>What Projects I did</h5>
            <h2>My Projects</h2>
            <div className="container portfolio_container">
                {
                    data.map(({ id, name, imgURL, github, demo }) => {
                        return (
                            <div key={id} className="portfolio_item">
                                <div className="portfolio_item-image">
                                    <img className="proj-img" src={imgURL} alt={name} />
                                    <div className="overlay">
                                        <h3>{name}</h3>
                                        <div className="portfolio_item-cta">
                                            <a href={github} className='btn'>GitHub</a>
                                            {/* <a href={demo} className='btn btn-primary' target='_blank' rel="noopener noreferrer">Live Demo</a> */}
                                            <Link to={`/project/${id}`} className='btn btn-secondary'>More Details</Link>
                                        </div> 
                                    </div>
                                </div>                  
                            </div>
                        );
                    })
                }
            </div>
        </section>
    );
}

export default Project;
